import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import classNames from "classnames";
import Image from "../../elements/image";
import SuperButton from "../../elements/super-button";
import Videojs from "../video-js";
import Heading from "../../elements/heading";

export default class HeroMedia extends Component {
  constructor(props, context) {
    super(props, context);
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.onScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  }
  onScroll() {
    const model = this.props;
    if (!this.videoNode) return;
    const { videoIsPlaying } = this.videoNode.state;
    const rect = this.mediaContainer.getBoundingClientRect();
    const winHeight = window.innerHeight || document.documentElement.clientHeight;
    const winWidth = window.innerWidth || document.documentElement.clientWidth;
    const inScreen = (rect.top >= 0 && rect.top <= winHeight) || (rect.bottom >= 0 && rect.bottom <= winHeight);
    if (inScreen && !videoIsPlaying && model.fields.videoAutoPlay.value && winWidth > 992 ) {
      setTimeout(v=>{
        this.videoNode.player.play();
      },20)
    }
  }
  heroMediaContent(model) {
    const { paddingAboveTop, paddingAboveBottom, gridType, alignment, backgroundColor, backgroundImage, order, overlineText, video, image, headingType, headingBody, body, bulletListItems, videoPlayText, videoAutoPlay, muted, CTA, showRadialGradiant } = model.fields;
    let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "none",
      bottom = paddingAboveBottom ? paddingAboveBottom.fields.phrase.value : "none";
    const heroMediaClasses = classNames("hero-media", "padding-top-" + top, "padding-bottom-" + bottom, {
      reverse: (order && order.fields.phrase.value) === "reverse",
      "grid-story": (gridType && gridType.fields.phrase.value) === "story",
      grid: (gridType && gridType.fields.phrase.value) === "normal"
    });
    const alignClass = classNames("full-width", "grid", {
      center: (alignment && alignment.fields.phrase.value) === "center",
      // grid: model.alignContent !== "center",
      right: (alignment && alignment.fields.phrase.value) === "right"
    });

    const mediaClassNames = classNames("media-container", "grid", {
      "with-gradiant": showRadialGradiant && showRadialGradiant.value
    });

    let divHeroMediaBackgroundStyle = {};

    if (backgroundColor) {
      divHeroMediaBackgroundStyle = {
        background: backgroundColor.fields.phrase.value
      };
    }

    if (backgroundImage && backgroundImage.value && backgroundImage.value.src) {
      divHeroMediaBackgroundStyle = {
        backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.5) ), url(" + backgroundImage.value.src + ")",
        backgroundsize: "contain"
      };
    }
    const videoOptions =
      video && video.value
        ? {
            sources: [
              {
                src: video.value.src,
                type: video.value.mimeType
              }
            ],
            poster: image.value.src,
            videoTitle: videoPlayText && videoPlayText.value,
            autoplay: videoAutoPlay.value,
            controls: true,
            muted: muted.value
          }
        : {};
    return (
      <div className={heroMediaClasses} style={divHeroMediaBackgroundStyle} datasourceid={this.props.rendering.dataSource}>
        {(Object.keys(image.value).length !== 0 || (video && video.value)) && (
          <div className={mediaClassNames} ref={e => (this.mediaContainer = e)}>
            {image.value && video && !video.value && <Image {...image.value} />}
            {video && video.value && <Videojs ref={e => (this.videoNode = e)} {...videoOptions} />}
          </div>
        )}

        {/* radial gradient when an image is present and radialGradient flag is true */}
        {image.value && showRadialGradiant.value && <div className="radial-gradient" />}

        <div className={alignClass}>
          {overlineText && overlineText.value && <span className="overline">{overlineText.value}</span>}
          <Heading
            {...{
              type: headingType ? headingType : { type: { fields: { phrase: { value: "h1" } } } },
              html: headingBody,
              typographyClass: "type-h1"
            }}
            className={"title show-on-scroll"}
          />

          {body && <RichText tag="p" className="body-text" field={body} />}

          {bulletListItems && bulletListItems.length > 0 && (
            <div className={"body-text"}>
              <ul>
                {bulletListItems.map((item, index) => {
                  return (
                    <li key={index}>
                      {item.fields.iconName && item.fields.iconName.value && item.fields.iconName.value.alt && (
                        <RichText
                          field={{
                            value: item.fields.iconName.value.alt
                          }}
                        />
                      )}
                      {item.fields.body && item.fields.body.value}
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div className={"button-container"}>{CTA && CTA.map((item, index) => item.fields && item.fields.ctatype && item.fields.ctatype.fields && <SuperButton key={index} {...item.fields} />)}</div>
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.fields) return null;
    let model = this.props,
      { gridType } = model.fields;
    //  var {video}=this.state;
    if ((gridType && gridType.fields.phrase.value) === "story") {
      return <div className={"grid"}>{this.heroMediaContent(model)}</div>;
    } else {
      return this.heroMediaContent(model);
    }
  }
}
